export default "__VITE_ASSET__526f5b92__"